import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { getI18nLang, type SupportedLanguage } from "@/i18n";

/**
 * Extract lang from pathname instead of useParams (which doesn't work
 * with the current /zh/* /ja/* route structure).
 */
export function useLocale() {
  const location = useLocation();
  const { i18n } = useTranslation();

  const match = location.pathname.match(/^\/(zh|ja)(\/|$)/);
  const currentLang: SupportedLanguage = match ? (match[1] as SupportedLanguage) : "en";
  const prefix = currentLang === "en" ? "" : `/${currentLang}`;

  useEffect(() => {
    const target = getI18nLang(currentLang);
    if (i18n.language !== target) {
      i18n.changeLanguage(target);
    }
  }, [currentLang, i18n]);

  const pathWithoutLang = location.pathname.replace(/^\/(zh|ja)/, "") || "/";

  return { currentLang, prefix, pathWithoutLang };
}
